import { IBaseQueryParameters } from '../index.js'

/**
 * This interface defines the path parameters for the endpoints available in the
 * `Treaty` endpoint class.
 */
export interface ITreatyPathParameters extends IBaseQueryParameters {
  /** The congress number. For example, the value can be `117` for the 117th Congress. */
  congress?: number

  /** The treaty assigned number. For example, this value can be `3324`. */
  treatyNumber?: number

  /** The treaty’s partition letter value. For example, the value can be A. */
  treatySuffix?: string
}
